<template>
  <div class="security-box">
    <van-cell-group :border="false">
      <div class="security-grade">
        <div class="grade-line">
          安全等级：
          <span class="security-grade-color">低</span>
        </div>
      </div>
      <van-cell :border="false" title="手机号" :value="phoneN(phoneNumber)" is-link />
      <van-cell :border="false" title="微信号" :value="wxNumber" is-link />
      <van-cell :border="false" title="银行卡" :value="bankCard" is-link />
    </van-cell-group>
    <div class="security-foot"></div>
  </div>
</template>

<script>
import URL from "@/api/api";
import { setLocal } from "@/utils/utils";
export default {
  data() {
    return {
      phoneNumber: '',
      wxNumber: '未绑定',
      bankCard: '未绑定',
    }
  },
  mounted() {
    this.getUser()
    this.checkOpenid()
  },
  methods: {
    checkOpenid() {
      let openid = localStorage.getItem("openid");
      this.$fetchPost(URL.checkOpenid.url + openid).then((res) => {
        if (res.data.code == 20000) {
          setLocal("cip", res.data.data.ip);
          if(res.data.data.bindingCardFlag=='1'){
            this.bankCard='已绑定'
          }
        }
      });
    },
    getUser() {
      let userId = localStorage.getItem('userid')
      this.$fetchGet(URL.getStaffsCard.url, { userId: userId }).then((res) => {
        this.phoneNumber = res.data.data.phone
      })
    },
    phoneN(phone) {
      phone = "" + phone;
      this.phoneNumber = phone.substr(0, 3) + "*****" + phone.substr(8)
      return this.phoneNumber
    }
  }
}
</script>

<style lang="less" scoped>
.security-box{
    height: 100vh;
    background: #FFFFFF;
}
.security-grade {
  width: 354.75px;
  height: 43.75px;
  line-height: 43.75px;
  margin: auto;
  font-size: 14px;
  font-weight: Medium;
  font-family: PingFang SC;
  color: #333333;
  border-bottom: 1px solid #EDEDED;
}
.grade-line {
  width: 102px;
  padding-left: 9.75px;
  margin-left: 6px;
  border-bottom: 1px solid #fa6618;
}
.security-grade-color {
  color: #fb6b0e;
}
.van-cell {
  width: 354.75px;
  height: 43.75px;
  line-height: 43.75px;
  padding: 0 0 0 9.75px;
  align-items: center;
  margin: auto;
  border-bottom: 1px solid #EDEDED;
}
.security-foot{
    width: 375px;
    height: 55px;
    background: #FA6618;
    opacity: 0.5;
    position: absolute;
    bottom: 0;
}
</style>